export const ContentFlag = Object.freeze({
    LOW_RISK_CR_EU: 'low_risk_cr_eu',
    LOW_RISK_CR_NON_EU: 'low_risk_cr_non_eu',
    HIGH_RISK_CR: 'high_risk_cr',
    CR_DEMO: 'cr_demo',
    EU_DEMO: 'eu_demo',
    EU_REAL: 'eu_real',
});
